import { SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { BaseSubChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/base-sub-chart';
import { PresetChartType } from '../chart-presets/const';
import type { STScatterStyle } from '@tencent/slide-sdk-model';
import type { IScatterChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import type {
    IScatterChartSeries,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/scatter-chart.interface';

export class ScatterChart extends BaseSubChart implements IScatterChart {
    public static convertDataUiToSdk(uiData, sdkData, rawUiData): void {
        this.convertSubChartUiToSdkByType(SubChartType.ScatterChart, uiData, sdkData, rawUiData);
    }

    public type = SubChartType.ScatterChart;
    public scatterStyle: STScatterStyle;

    public declare series: IScatterChartSeries[];

    public getPresetChartType(): PresetChartType {
        // todo 待拆分细分类型
        return PresetChartType.SCATTER;
    }
}

